module.exports = __webpack_public_path__ + "sala-de-cinema.26a895edc5548069045fa5e0ae519d43.jpg";